import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./Pricing.module.css";
import { UserContext } from "../../context/UserContext";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FirebaseApp } from "../../services/firebaseConfig";
import Button from "../../components/common/Button";

export default function Pricing() {
  const { i18n, t } = useTranslation("home");
  const language = i18n.language; // ex: "en" ou "pt"
  const [currency, setCurrency] = useState(language === "pt" ? "BRL" : "USD");

  const { userData } = useContext(UserContext);

  const functions = getFunctions(FirebaseApp, "us-central1");
  const createCheckoutSession = httpsCallable(
    functions,
    "createCheckoutSession"
  );

  const [loadingType, setLoadingType] = useState(null);
  const [error, setError] = useState(null);

  async function startCheckout(productType) {
    if (!userData) {
      window.location.href = "/login?next=/pricing";
      return;
    }

    if (!userData.personalityTraits) {
      window.location.href = "/personality-quiz";
      return;
    }

    setLoadingType(productType);
    setError(null);

    try {
      const res = await createCheckoutSession({
        productType,
        currency,
      });

      window.location.href = res.data.url;
    } catch (err) {
      console.error(err);
      setError(t("pricing.error"));
      setLoadingType(null);
    }
  }

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <h1>{t("pricing.title")}</h1>
        <p className={styles.subtitle}>{t("pricing.subtitle")}</p>

        {!userData && <p className={styles.muted}>{t("pricing.infoUser")}</p>}

        {userData && !userData.personalityTraits && (
          <p className={styles.muted}>{t("pricing.infoTest")}</p>
        )}

        <div className={styles.contentGrid}>
          {/* RELATÓRIO */}
          <div className={styles.card}>
            <h3>{t("pricing.cardTitle")}</h3>
            <p className={styles.description}>{t("pricing.cardText")}</p>
            <div className={styles.currencyDiv}>
              <p>{t("pricing.currency")}</p>
              <p
                onClick={() => setCurrency("USD")}
                className={
                  currency === "USD" ? styles.currencyActive : styles.currency
                }
              >
                USD
              </p>
              <p
                onClick={() => setCurrency("BRL")}
                className={
                  currency === "BRL" ? styles.currencyActive : styles.currency
                }
              >
                BRL
              </p>
            </div>
            {currency === "BRL" ? (
              <p className={styles.price}>R$ 39,00 BRL</p>
            ) : (
              <p className={styles.price}>$ 8.00 USD</p>
            )}

            <Button
              disabled={loadingType === "report"}
              onClick={() => startCheckout("report")}
            >
              {loadingType === "report"
                ? t("pricing.ButtonLoading")
                : t("pricing.ButtonBuy")}
            </Button>
          </div>

          {/* RELATÓRIO + EBOOK (RECOMENDADO) */}
          {/* <div className={`${styles.card} ${styles.featured}`}>
            <h3>Relatório + Ebook</h3>
            <p className={styles.description}>
              Relatório completo + Ebook com 27 quadrinhos de metáforas baseadas
              em ACT para aprofundar a compreensão emocional.
            </p>
            <p className={styles.price}>R$ 45,00</p>

            <Button
              disabled={loadingType === "report_ebook"}
              onClick={() => startCheckout("report_ebook")}
            >
              {loadingType === "report_ebook"
                ? "Redirecionando..."
                : "Relatório + Ebook"}
            </Button>
          </div> */}

          {/* PLANO MENSAL */}
          {/* <div className={styles.card}>
            <h3>Plano Mensal</h3>
            <p className={styles.description}>
              Relatório completo + acesso contínuo ao aplicativo Ibhava Daily
              para acompanhamento e desenvolvimento pessoal.
            </p>
            <p className={styles.price}>
              R$ 29,00 <span className={styles.period}>/ mês</span>
            </p>

            <Button
              disabled={loadingType === "monthly"}
              onClick={() => startCheckout("monthly")}
            >
              {loadingType === "monthly"
                ? "Redirecionando..."
                : "Assinar plano mensal"}
            </Button>
          </div> */}
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <p style={{ marginTop: 24 }}>{t("pricing.stripe")}</p>
        {/* <p className={styles.muted} style={{ marginTop: 24 }}>
          Pagamento seguro via Stripe. Cancelamento simples a qualquer momento.
        </p> */}
      </div>
    </section>
  );
}
